import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';

type FieldTemplate = Pick<QuestionnaireApiModels.FieldTemplate, 'type'>;

const isEmptyValue = (value: unknown, fieldTemplate: FieldTemplate | undefined): boolean => {
  if (value === null || value === undefined) {
    return true;
  }

  if (fieldTemplate && (fieldTemplate.type === 'list' || fieldTemplate.type === 'table')) {
    return Array.isArray(value) && value.length === 0;
  }

  if (fieldTemplate && fieldTemplate.type === 'currency') {
    if (typeof value !== 'object') {
      return true;
    }

    const hasAmount = 'amount' in value && (value.amount !== null && value.amount !== undefined);
    const hasText = 'text' in value && (value.text !== null && value.text !== undefined);
    const hasIsUnknown = 'isUnknown' in value && value.isUnknown === true;

    return !(hasAmount || hasText || hasIsUnknown);
  }

  if (fieldTemplate && fieldTemplate.type === 'short-text') {
    return value === '';
  }

  return false;
};

export default isEmptyValue;